import Button from "@app/sharedComponents/Button/Button";
import { ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import { X } from '@sharedComponents/Icons';

const InterestInfo = ({closeBottomSheet,estimatedInterestTillEndOfCycle,nextEMIAmount,interestAccuredNotDue}) =>{
    return(
        <ThemedView p="lg">
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center" mb="2xl">
                <ThemedText variant="h5s" color="text-primary">Estimated interest due</ThemedText>
            </ThemedView>
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="lg"
                >
                <ThemedText variant="b3r" color='text-primary'>
                    Interest accrued till date
                </ThemedText>
                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(interestAccuredNotDue)}
                </ThemedText>
            </ThemedView>
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                >
                <ThemedText variant="b3r" color='text-primary'>
                    Estimated interest till end of cycle
                </ThemedText>
                <ThemedText variant="b3r" color='text-primary'>
                    ₹{formatIndianCurrency(estimatedInterestTillEndOfCycle)}
                </ThemedText>
            </ThemedView>
            <ThemedView height={1} backgroundColor="border-secondary" width={"100%"} my="lg" />
            <ThemedView
                flexDirection='row'
                alignItems="center"
                justifyContent="space-between"
                mb="2xl"
                >
                <ThemedText variant="b3s" color='text-primary'>
                   Estimated EMI amount
                </ThemedText>
                <ThemedText variant="b3s" color='text-primary'>
                    ₹{formatIndianCurrency(nextEMIAmount)}
                </ThemedText>
            </ThemedView>
            <Button label="Ok, got it!" type="SOLID" handlePress={closeBottomSheet}/>
        </ThemedView>
    )
}

export default InterestInfo;